import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class RosterFudokan extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterTuesday1'>
      <div><Link to='/'>Home</Link></div>
      <h3>FUDOKAN DOJO's MEMBERS</h3>
      <br />
      <br />

      <div><Link to='/conduct-wissarutm'>1. AAT  2462  MR.WISSARUT MAHARAKKHAKA(Dojocho)(A)</Link></div>
      <br />
      <div><Link to='/conduct-pummad'>2. AAT  2725  MR.PUMMA DOUNGRUTANA(A)</Link></div>
      <br />
      <div><Link to='/conduct-choochaic'>3. AAT  2608  MR.CHOOCHAI CHINNAWONG(A)</Link></div>
      <br />
      <div><Link to='/conduct-karlr'>4. AAT  6073  MR.KARL RASMIDATTA(A)</Link></div>
      <br />
      <div><Link to='/conduct-busayarinr'>5. AAT  2609  MS.BUSAYARIN  RUENRUAISAP(A)</Link></div>
      <br />
      <div><Link to='/conduct-aurathail'>6. AAT  2785  MS.AURATHAI LOYMAKE(A)</Link></div>
      <br />
      <div><Link to='/conduct-sunchuym'>7. AAT  4920  MR.SUNCHUY MOSIKARAT(A)</Link></div>
      <br />
      <div><Link to='/conduct-nithiss'>8. AAT  8055  MR.NITHIS SIWATHEWINTRA(A)</Link></div>
      <br />
      <div><Link to='/conduct-phusins'>9. AAT  8056  MR.PHUSIN SIWATHEWINTRA(A)</Link></div>
      <br />
        <br />
        <div>
          Thailand's Aikido Association Registration and Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default RosterFudokan;
